<section class="app-header">
  <div
    class="app-header-inner"
    [style.background-color]="color | async"
    [style.--mat-button-text-label-text-color]="textColor | async"
  >
    <div class="d-lg-none d-xl-none" style="float: left">
      <button mat-button myToggleOffcanvasNav class="md-button header-icon toggle-sidebar-btn">
        <div><i class="material-icons">menu</i></div>
      </button>
    </div>

    <div class="brand d-none d-lg-inline-block d-xl-inline-block">
      <h2>
        <a [routerLink]="['/']" [style.color]="textColor | async">{{ siteTitle | async }}</a>
      </h2>
    </div>

    @if ((devEnvironment | async) == true) {
      <div id="header-dev-environment">
        <i class="material-icons">warning</i>
        <span id="header-dev-environment__text">{{ devEnvironmentLabel | async }}</span>
      </div>
    }

    <div class="top-nav-right">
      <ul class="list-unstyled">
        @if ((administratorAccess | async) == true) {
          <li>
            <button mat-button class="header-btn" (click)="openFilterBuilder()">
              <div><i class="material-icons">search</i></div>
            </button>
          </li>
        }
        <li>
          <button
            mat-button
            class="header-btn profile-btn"
            [matMenuTriggerFor]="menu"
            matTooltip="{{ (user | async)?.displayname }}"
          >
            @if ((user | async)?.photo) {
              <img
                [src]="'data:image/jpg;base64,' + (user | async)?.photo"
                alt=""
                class="rounded"
                style="width: 45px; height: 45px"
              />
            } @else {
              <mat-icon>account_box</mat-icon>
            }
            <span class="hidden-xs-down">{{ (user | async)?.displayname }}</span>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openProfile()">
              <mat-icon>person</mat-icon>
              <span>Profile</span>
            </button>
            <button mat-menu-item>
              <mat-slide-toggle (click)="darkMode()" [(ngModel)]="isChecked"></mat-slide-toggle>
              <span (click)="darkModeText()"
                ><language key="DarkMode" defaultValue="Dark Mode"></language
              ></span>
            </button>
            @if (isCloud) {
              <button mat-menu-item (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span><language key="Logout" defaultValue="Logout"></language></span>
              </button>
            }
          </mat-menu>
        </li>
      </ul>
    </div>
  </div>
</section>
